// Standardized badge marking a page that is LIVE but has one or more specific
// controls still pending a backend action. The point (S-493) is an honest
// live-vs-pending distinction a non-technical viewer can read — "Coming soon",
// in plain language, naming what works and what doesn't (ideally with the story
// that owes it) — NOT an engineering "mockup / not functional yet" label, which
// reads as if the whole page is fake when only one or two controls are pending.
//
// Pass `detail` to name exactly which controls are pending and reassure that the
// rest of the page is live.
//
// Distinct from <NotYetBuilt>, which replaces an *entire* unbuilt screen.
export function MockupNotice({ detail }: { detail?: string }): JSX.Element {
  return (
    <div className="mockup-notice" role="status">
      <span className="mockup-notice__tag">Coming soon</span>
      {detail !== undefined && detail.length > 0 && (
        <span className="mockup-notice__detail">{detail}</span>
      )}
    </div>
  );
}
